import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { TableOfContents } from "@/components/TableOfContents";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { RelatedTools } from "@/components/RelatedTools";
import { RelatedInsights } from "@/components/RelatedInsights";
import { getRelatedInsightsForInsight } from "@/data/toolInsightLinks";
import { EmailBlacklistsHeroSection } from "@/components/insights/email-blacklists/EmailBlacklistsHeroSection";
import { EmailBlacklistsTakeaway } from "@/components/insights/email-blacklists/EmailBlacklistsTakeaway";
import { EmailBlacklistsFounderQuote } from "@/components/insights/email-blacklists/EmailBlacklistsFounderQuote";
import { EmailBlacklistsKeyFindings } from "@/components/insights/email-blacklists/EmailBlacklistsKeyFindings";
import { EmailBlacklistsTwoTypes } from "@/components/insights/email-blacklists/EmailBlacklistsTwoTypes";
import { EmailBlacklistsHowListed } from "@/components/insights/email-blacklists/EmailBlacklistsHowListed";
import { EmailBlacklistsSeverity } from "@/components/insights/email-blacklists/EmailBlacklistsSeverity";
import { EmailBlacklistsReferences } from "@/components/insights/email-blacklists/EmailBlacklistsReferences";

const EmailBlacklistsExplained = () => {
  return (
    <>
      <InsightSEO
        slug="email-blacklists-explained"
        additionalKeywords={[
          "email blacklist",
          "Spamhaus DBL",
          "SURBL",
          "URIBL",
          "spam traps",
          "domain reputation",
          "inbox placement",
        ]}
      />
      <InsightEngagementTracker
        slug="email-blacklists-explained"
        title="Email Blacklists Explained"
      />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb
          category="Email Deliverability"
          currentPage="Email Blacklists Explained"
        />
        <EmailBlacklistsHeroSection />

        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <EmailBlacklistsTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <EmailBlacklistsFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <EmailBlacklistsKeyFindings />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <EmailBlacklistsTwoTypes />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <EmailBlacklistsHowListed />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <EmailBlacklistsSeverity />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="email-blacklists-explained" />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <EmailBlacklistsReferences />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="email-blacklists-explained" />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <RelatedInsights
            slugs={getRelatedInsightsForInsight("email-blacklists-explained")}
            limit={4}
          />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default EmailBlacklistsExplained;